export const createUserUrl = (url: string): string => `user/${url}`;
